import { render, staticRenderFns } from "./DerivativesTable.vue?vue&type=template&id=08be713c&scoped=true"
import script from "./DerivativesTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./DerivativesTable.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./DerivativesTable.vue?vue&type=style&index=0&id=08be713c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08be713c",
  null
  
)

export default component.exports